import { render, staticRenderFns } from "./GameOverModal.vue?vue&type=template&id=2f0de3dd&"
import script from "./GameOverModal.vue?vue&type=script&lang=js&"
export * from "./GameOverModal.vue?vue&type=script&lang=js&"
import style0 from "./GameOverModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports